const articleHighlight = () => {
  const prefix = `article_highlight`,
    component = document.querySelectorAll(`.${prefix}`);

  if (exists(`.${prefix}`)) {
    for (let i = 0; i < component.length; i++) {
      const componentIndex = component[i],
        title = componentIndex.getAttribute('data-title'),
        imgPath = componentIndex.getAttribute('data-image');

      if (imgPath) {
        new Element({
          type: 'img',
          classes: [
            `${prefix}-icon`,
          ],
          src: imgPath,
          alt: componentIndex.getAttribute('data-image-alt'),
          append: {
            parent: componentIndex,
            before: componentIndex.childNodes[0]
          }
        })
      }

      if (title) {
        new Element({
          type: 'h3',
          classes: 'heading--sm',
          content: title,
          append: {
            parent: componentIndex,
            before: componentIndex.childNodes[1]
          }
        })
      }
    }
  }
};
articleHighlight();